import { UserIdSchema as a } from "@hprofits/shared";
import { UserRoleSchema as s } from "@hprofits/shared/auth";
import { z as e } from "zod";
import { PROFILE_MESSENGER_ID_MAX_LENGTH as d, ProfileMessengerSchema as g, PROFILE_NAME_MAX_LENGTH as o } from "../auth/schemas.js";
import { ErrorMetaSchema as p } from "../common/errors/schemas.js";
import { PaginationSchema as S, ApiSortModeSchema as h, paginatedList as y } from "../common/pagination.js";
import { idListQueryParam as u } from "../common/params.js";
const b = 100, f = 50, U = e.union([e.boolean(), e.enum(["true", "false"]).transform((r) => r === "true")]), E = e.enum(["id", "email", "createdAt", "isEmailVerified", "isBanned", "paymentType"]), I = e.enum(["active", "banned"]), A = e.enum(["verified", "unverified"]), j = S.extend({
  pageSize: e.coerce.number().int().min(1).max(b).default(f),
  sortBy: E.default("createdAt"),
  sortDirection: h.default("desc"),
  search: e.string().trim().min(1).optional(),
  roles: e.array(s).optional(),
  managerIds: u(a).optional(),
  withoutManager: U.optional(),
  statuses: e.array(I).optional(),
  verification: e.array(A).optional()
}).readonly(), l = e.object({
  id: a,
  email: e.string()
}).readonly(), m = e.object({
  id: e.int().positive(),
  name: e.string()
}).readonly(), x = e.object({
  id: a,
  email: e.string(),
  firstName: e.string(),
  lastName: e.string(),
  roles: e.array(s).readonly(),
  isBanned: e.boolean(),
  isEmailVerified: e.boolean(),
  manager: l.nullable(),
  paymentType: m.nullable(),
  createdAt: e.string()
}).readonly(), G = y(x), n = e.object({
  userId: e.coerce.number().pipe(a)
}), c = e.int().positive(), D = e.object({
  id: a,
  email: e.string(),
  firstName: e.string(),
  lastName: e.string(),
  isEmailVerified: e.boolean(),
  messenger: e.string().nullable(),
  messengerId: e.string().nullable(),
  paymentType: m.nullable(),
  balanceAlerts: e.boolean(),
  roles: e.array(s).readonly(),
  grants: e.array(c).readonly(),
  manager: l.nullable(),
  isBanned: e.boolean(),
  banDescription: e.string(),
  createdAt: e.string()
}).readonly(), w = n.extend({
  firstName: e.string().trim().min(1).max(o),
  lastName: e.string().trim().min(1).max(o),
  messenger: g.nullable(),
  messengerId: e.string().trim().min(1).max(d).nullable(),
  paymentTypeId: e.int().positive(),
  balanceAlerts: e.boolean()
}).strict().refine(({ messenger: r, messengerId: i }) => r === null == (i === null), {
  error: "Set or clear the messenger together with its contact",
  path: ["messengerId"]
}).readonly(), O = n.extend({
  managerId: a
}).strict().readonly(), V = n.extend({
  reason: e.string().trim().min(1)
}).strict().readonly(), F = n.extend({
  roles: e.array(s).readonly()
}).strict().readonly(), Q = n.extend({
  grants: e.array(c).readonly()
}).strict().readonly(), t = e.int().positive(), X = e.object({
  sspId: t.nullable(),
  sspName: e.string().nullable(),
  dspId: t.nullable(),
  dspName: e.string().nullable()
}).readonly(), z = n.extend({
  sspId: t.nullable(),
  dspId: t.nullable(),
  replace: e.boolean()
}).strict().refine(({ sspId: r, dspId: i }) => r !== null || i !== null, {
  error: "Pick an SSP or a DSP; remove the binding to clear both",
  path: ["sspId"]
}).readonly(), N = e.enum(["ssp", "dsp"]), P = e.object({
  side: N,
  sideName: e.string(),
  userId: a,
  email: e.string()
}).readonly(), C = p.extend({
  owners: e.array(P).readonly()
}).readonly();
export {
  C as AdExchangeOwnerConflictDataSchema,
  P as AdExchangeOwnerSchema,
  t as AdExchangeSideIdSchema,
  N as AdExchangeSideSchema,
  O as AssignUserManagerSchema,
  V as BanUserSchema,
  z as BindUserAdExchangeSchema,
  b as USERS_MAX_PAGE_SIZE,
  Q as UpdateUserGrantsSchema,
  w as UpdateUserProfileSchema,
  F as UpdateUserRolesSchema,
  X as UserAdExchangeBindingSchema,
  D as UserCardSchema,
  c as UserGrantIdSchema,
  n as UserIdParamSchema,
  x as UserListItemSchema,
  l as UserManagerSchema,
  m as UserPaymentTypeSchema,
  I as UserStatusSchema,
  A as UserVerificationSchema,
  j as UsersQuerySchema,
  G as UsersResponseSchema,
  E as UsersSortBySchema
};
//# sourceMappingURL=schemas.js.map
